<template>
    <div :style="cssVars">

    <b-card >
      <template v-slot:header v-if="heading">
        <font-awesome-icon v-if="icon" :icon="icon" class="mr-2"/>
        <span>{{heading}}</span>
      </template>
      <!-- <div slot="header" v-bind:style="color">
        <font-awesome-icon v-if="icon" :icon="icon" class="mr-2"/>
        <span>{{heading}}</span>
      </div> -->
      <slot></slot>
    </b-card>
    </div>
</template>

<script>
export default {
  data() {
    return {
      colors: ["#8C1D40", "#FFC627", "#78BE20", "#00A3E0", "#FF7F32", "#5C6670"]
    };
  },

  props: {
    heading: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  },

  computed: {
    cssVars() {
      return {
        "--border-color": this.colors[_.random(0, this.colors.length - 1)]
      };
    },
    color: function() {
      var colors = this.colors;
      return { color: colors[_.random(0, colors.length - 1)] };

      // return {
      //   padding: "",
      //   "margin-bottom": 0,
      //   "background-color": "#fff",
      //   "border-bottom": "1px solid rgba(0, 0, 0, 0.125)",
      //   "border-top": "0.25em solid",
      //   "border-top-color": colors[_.random(0, colors.length - 1)]
      // };
    }
  }
};
</script>

<style scoped>
.widget {
  margin: 0 auto 1em;
  border-bottom-color: #c1c2c3;
}

.widget.widget-gray {
  background: #fafafa;
  /* background: #f5f5f5; */
}
.widget.widget-gray > .widget-head {
  background: #e9e9e9;
  border-color: #d1d2d3;
  border-bottom-color: #990033;
  box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
  -moz-box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
  -webkit-box-shadow: inset 1px 1px 1px rgba(255, 255, 255, 0.6),
    inset -1px -1px 1px rgba(0, 0, 0, 0);
}
.widget.widget-gray > .widget-head .heading {
  /* color: #770033; */
  text-shadow: 0 1px 0 #fff;
}
.widget.widget-gray > .widget-head .heading.glyphicons i:before {
  background: none;
  color: #555;
  border-color: rgba(0, 0, 0, 0.1);
}
.card {
  margin: 0 auto 1em;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-top: 0.25em solid var(--border-color);
}
.card-header-maroon {
  border-top: 0.25em solid #8c1d40;
}
.card-header-gold {
  border-top: 0.25em solid #ffc627;
}
.card-header-green {
  border-top: 0.25em solid #78be20;
}
.card-header-blue {
  border-top: 0.25em solid #00a3e0;
}
.card-header-orange {
  border-top: 0.25em solid #ff7f32;
}
.card-header-grey {
  border-top: 0.25em solid #5c6670;
}
</style>
